<section class="">
  <div class="mat-account-wrapper p-0">
    <div class="createuser-contentbox py-0">
      <div class="row mb-2">
        <div class="col-sm-3">
          <label class="text-blacka fs-18 font-bold mb-3">Create User</label>
        </div>
        <div class="col-sm-9 text-end">
          <span *ngIf="!isEdit">
            <mat-icon matTooltip="Reset Mat Account Creation Form" (click)="clearSchoolUserForm()">refresh</mat-icon>
          </span>
          <button type="button" class="btn theme-btn px-3 ms-3" (click)="downloadFile()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Download Template
          </button>
          <input hidden multiple type="file" accept=".xlsx, .xls, .csv" #uploadFileInput (change)="loadExcelData($event)" />
          <button type="button" class="btn theme-btn px-3 ms-3" (click)="bulkUpload()">
            <img class="me-2" src="../assets/images/document-upload.svg" alt=""/>Bulk Upload
          </button>
        </div>
      </div>
      <div class="bg-white row justify-content-between align-items-center radius8 mb-4">
        <div [formGroup]="schoolDetailsForm" class="col-sm-12">
          <div formArrayName="schools" class="tabs mb-0 tab-container">
            <ng-template #formFields let-school="school" let-schoolIndex="index">
              <div [formGroupName]="schoolIndex">
                <div class="row my-2 text-end">
                  <div class="col-sm-12">
                    <button type="button" class="btn theme-btn-blueoutline w185 px-2 me-3 fs-14" [disabled]="school.invalid"
                      (click)="openAddSchoolUserPopup(schoolIndex)">
                      <img class="me-2" src="../assets/images/add.svg" alt="" />
                      Add Another User
                    </button>
                  </div>
                </div>
                <div *ngIf="showSchoolUserDetailsList" class="create-user-section">
                  <app-user-details [schoolUserList]="schoolUserData" [clientAccountId]="clientAccountId" [roles] = "roles"
                    [packageId]="assignedPackageId" (actionEmitter)="actionTriggered($event)" [isSchoolUser]="true" [independentSchoolId]="schoolData && schoolData.length && schoolData[this.selectedIndex].schoolId || 0">
                  </app-user-details>
                </div>
                <div *ngIf="!showSchoolUserDetailsList" formArrayName="schoolUsers" class="school-user-form">
                  <div *ngFor="let schoolUser of school.get('schoolUsers').controls; let userIndex = index" [formGroupName]="userIndex">
                    <button style="float: right;" *ngIf="school.get('schoolUsers').controls.length > 1" type="button" class="btn link-delete link-delete-school border-red px-2 ms-3 fs-14 col-md-2" (click)="removeSchoolUser(selectedIndex,userIndex)">
                      <img class="me-2" src="../assets/images/delete-icon.svg" alt=""/>
                      Delete User
                    </button>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-4 mat-account-selectoption">
                          <mat-label class="black-text fs-14 mb-1">Title</mat-label>
                          <mat-form-field>
                            <mat-select [required]="true" formControlName="title" [class.is-invalid]="
                                                  schoolUser.get('title')!.invalid &&
                                                  schoolUser.get('title')!.touched">
                              @for (title of ['Ms', 'Mrs', 'Mr']; track title)
                              {
                              <mat-option [value]="title">{{ title }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <div *ngIf="
                                            (schoolUser.get('title')!.invalid &&
                                            schoolUser.get('title')!.touched) ||
                                            schoolUser.get('title')!.dirty">
                            <small *ngIf="schoolUser.get('title')!.errors?.['required']" class="text-danger fs-13">Title is
                              required</small>
                            <small *ngIf="schoolUser.get('title')!.errors?.['pattern']" class="text-danger fs-13">Please provide a valid
                              Title
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <label class="black-text fs-14 mb-1">First Name</label>
                          <input type="text" [required]="true" formControlName="firstName" class="form-control"
                            [readOnly]="isEdit && schoolUser.get('schoolUserId')!.value > 0" [class.is-invalid]="
                                                schoolUser.get('firstName')!.invalid &&
                                                schoolUser.get('firstName')!.touched" />
                          <div *ngIf="
                                                (schoolUser.get('firstName')!.invalid &&
                                                schoolUser.get('firstName')!.touched) ||
                                                schoolUser.get('firstName')!.dirty">
                            <small *ngIf="schoolUser.get('firstName')!.errors?.['required']" class="text-danger fs-13">First Name is
                              required</small>
                            <small *ngIf="schoolUser.get('firstName')!.errors?.['pattern']" class="text-danger fs-13">Please provide a
                              valid First Name</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <label class="black-text fs-14 mb-1">Last Name</label>
                          <input type="text" [required]="true" formControlName="lastName" class="form-control"
                            [readOnly]="isEdit && schoolUser.get('schoolUserId')!.value > 0" [class.is-invalid]="
                                                schoolUser.get('lastName')!.invalid &&
                                                schoolUser.get('lastName')!.touched" />
                          <div *ngIf="
                                                (schoolUser.get('lastName')!.invalid &&
                                                schoolUser.get('lastName')!.touched) ||
                                                schoolUser.get('lastName')!.dirty">
                            <small *ngIf="schoolUser.get('lastName')!.errors?.['required']" class="text-danger fs-13">Last Name is
                              required</small>
                            <small *ngIf="schoolUser.get('lastName')!.errors?.['pattern']" class="text-danger fs-13">Please provide a
                              valid Last Name</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <label class="black-text fs-14 mb-1">Email Address</label>
                          <input type="text" [required]="true" formControlName="emailId" class="form-control"
                            [readOnly]="isEdit && schoolUser.get('schoolUserId')!.value > 0" [class.is-invalid]="
                                                schoolUser.get('emailId')!.invalid &&
                                                schoolUser.get('emailId')!.touched" />
                          <div *ngIf="
                                                (schoolUser.get('emailId')!.invalid &&
                                                schoolUser.get('emailId')!.touched) ||
                                                schoolUser.get('emailId')!.dirty">
                            <small *ngIf="schoolUser.get('emailId')!.errors?.['required']" class="text-danger fs-13">Email Address is
                              required</small>
                            <small *ngIf="schoolUser.get('emailId')!.errors?.['pattern']" class="text-danger fs-13 mt-2">Please provide a
                              valid Email Address</small>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 mb-0 contact-number">
                        <label class="black-text fs-14 mb-1">Contact Number</label>
                        <mat-form-field class="contact-mat-form" appearance="outline" [class.is-invalid]="
                                              schoolUser.get('contactNumber')!.invalid &&
                                              schoolUser.get('contactNumber')!.touched">
                          <ngx-mat-intl-tel-input [enablePlaceholder]="true" [required]="true" [enableSearch]="true"
                            formControlName="contactNumber" onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            [preferredCountries]="['gb']">
                          </ngx-mat-intl-tel-input>
                        </mat-form-field>
                        <div *ngIf="
                                              (schoolUser.get('contactNumber')!.invalid &&
                                              schoolUser.get('contactNumber')!.touched) ||
                                              schoolUser.get('contactNumber')!.dirty">
                          <small *ngIf="
                                                schoolUser.get('contactNumber')!.invalid" class="text-danger fs-13">Please provide a
                            valid Contact Number</small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-4 mat-account-selectoption">
                          <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Assign Role</span>
                            <mat-icon matTooltip="Click + button to create a role" class="ms-2 fs-22">info</mat-icon>
                          </div>
                        <div class="d-flex assign-role-select">
                          <mat-form-field>
                            <mat-select [required]="true" multiple formControlName="role" [class.is-invalid]="
                                                  schoolUser.get('role')!.invalid &&
                                                  schoolUser.get('role')!.touched">
                              @for (roleValue of filterRolesForIndependentSchools(); track roleValue)
                              {
                              <mat-option [value]="roleValue">{{ roleValue.roleName }}</mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                          <button
                            type="button"
                            class="btn theme-btn-outline create-roleoutline-btn pt-2"
                            (click)="createRole()">
                            +
                          </button>
                        
                          </div>
                          <div *ngIf="
                          (schoolUser.get('role')!.invalid &&
                          schoolUser.get('role')!.touched) ||
                          schoolUser.get('role')!.dirty">
                          <small *ngIf="schoolUser.get('role')!.errors?.['required']" class="text-danger fs-13">Role is
                          required</small>
                          <small *ngIf="schoolUser.get('role')!.errors?.['pattern']" class="text-danger fs-13">Please provide a valid
                           Role
                        </small>
                         </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="mb-4">
                          <div class="d-flex">
                            <span class="black-text fs-14 mb-1">Upload</span>
                            <mat-icon matTooltip="Attach documents related to School User" class="ms-2 fs-22">info</mat-icon>
                          </div>
                          <div class="mt-0 px-3 py-3 custom-file-input">
                            <div class="file-input-wrapper">
                              <span class="file-name">{{ selectedFileCount[selectedIndex] > 0 ? selectedFileCount[selectedIndex] + ' file(s) selected' : 'Click to upload' }}</span>
                              <input hidden multiple type="file" #userFileInput (change)="onFileSelected($event, selectedIndex)" />
                              <button class="btn theme-btn px-2 ms-3 border-sm-0" mat-raised-button color="primary"
                                (click)="uploadFromLocal($event, selectedIndex)">
                                Upload
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </ng-template>

            <ng-container>
              <mat-tab-group (selectedTabChange)= "onSchoolChange($event.index)"  #tabGroup>
                <mat-tab [label]="school.get('schoolName')!.value" *ngFor="let school of schools.controls; let i = index">
                  <div>
                    <ng-container *ngTemplateOutlet="formFields; context: {school: school, index: i}"></ng-container>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-sm-12 text-end" *ngIf="(userRole.includes(rolesMaster.SchoolAdmin) ||
                                         userRole.includes(rolesMaster.MatAdmin) && standaloneMenu)">
    <div class="mt-0 mt-sm-0 pt-0 pt-sm-0">
      <button type="button" class="btn theme-btn-outline create-package">Cancel</button>
      <button type="button" class="btn theme-btn px-5 ms-3">
        
      </button>
    </div>
  </div>
</section>
